import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	LandFormInput,
	LandFormOutput,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { FlatRowFormSwitch } from "web_myplann/Shared/Components/FlatRow/FlatRowFormSwitch";
import { FlatRowFormTextarea } from "web_myplann/Shared/Components/FlatRow/FlatRowFormTextarea";

type Props = {
	control: Control<LandFormInput, unknown, LandFormOutput>;
};

const PageResources = Resources.Portfolio.AddLand;

export const LandClassificationFields = ({ control }: Props) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<Typography variant="sectionLabel">
				{t(PageResources.Sections.classification)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormSwitch
					redesigned
					control={control}
					name="forInvestments"
					label={t(Resources.Portfolio.AddShared.Fields.forInvestments)}
					isLast
				/>
			</Stack>

			<Typography variant="sectionLabel">
				{t(PageResources.Sections.description)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<FlatRowFormTextarea
					control={control}
					name="description"
					label={t(PageResources.Fields.description)}
					placeholder={t(PageResources.descriptionPlaceholder)}
					rows={1}
					isLast
				/>
			</Stack>
		</>
	);
};
